<template>
  <div class="text-center pt-5">
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <div class="re-menu">
        <div class="d-flex justify-center">
          <div class="re-hr" />
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="1"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'reading' ? 'success' : 'error'"
              router
              :to="`/Book/Reading/${bookId}`"
            >
              <v-icon>mdi-book-open-page-variant-outline</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="2"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'listening' ? 'success' : 'error'"
              router
              :to="`/Book/Listening/${bookId}`"
            >
              <v-icon>mdi-headphones</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="3"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'watching' ? 'success' : 'error'"
              router
              :to="`/Book/Watching/${bookId}`"
            >
              <v-icon>mdi-movie-roll</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="4"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'exam' ? 'success' : 'error'"
              router
              :to="`/Book/Exam/${bookId}`"
            >
              <v-icon>mdi-list-status</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="5"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'report' ? 'success' : 'error'"
              router
              :to="`/Book/Report/${bookId}`"
            >
              <v-icon>mdi-file-chart</v-icon>
            </v-btn>
          </v-badge>
          <v-badge
            class="mx-5"
            color="warning"
            bordered
            overlap
            content="6"
            left
          >
            <v-btn
              fab
              depressed
              :color="state === 'certificate' ? 'success' : 'error'"
              router
              :to="`/Book/Certificate/${bookId}`"
            >
              <v-icon>mdi-certificate-outline</v-icon>
            </v-btn>
          </v-badge>
        </div>
      </div>
      <div class="d-flex justify-center pt-2">
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... بخوانیم
        </div>
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... بشنویم
        </div>
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... ببینیم
        </div>
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... بسنجیم
        </div>
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... بفهمیم
        </div>
        <div class="re-caption dastnevis text-center gray--text lighten-2 mx-6">
          ... بگیریم
        </div>
      </div>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="1" left>
            <v-btn
              fab
              depressed
              :color="state === 'reading' ? 'success' : 'error'"
              router
              :to="`/Book/Reading/${bookId}`"
            >
              <v-icon>mdi-book-open-page-variant-outline</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... بخوانیم
          </div>
        </v-col>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="2" left>
            <v-btn
              fab
              depressed
              :color="state === 'listening' ? 'success' : 'error'"
              router
              :to="`/Book/Listening/${bookId}`"
            >
              <v-icon>mdi-headphones</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... بشنویم
          </div>
        </v-col>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="3" left>
            <v-btn
              fab
              depressed
              :color="state === 'watching' ? 'success' : 'error'"
              router
              :to="`/Book/Watching/${bookId}`"
            >
              <v-icon>mdi-movie-roll</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... ببینیم
          </div>
        </v-col>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="4" left>
            <v-btn
              fab
              depressed
              :color="state === 'exam' ? 'success' : 'error'"
              router
              :to="`/Book/Exam/${bookId}`"
            >
              <v-icon>mdi-list-status</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... بسنجیم
          </div>
        </v-col>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="5" left>
            <v-btn
              fab
              depressed
              :color="state === 'report' ? 'success' : 'error'"
              router
              :to="`/Book/Report/${bookId}`"
            >
              <v-icon>mdi-file-chart</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... بفهمیم
          </div>
        </v-col>
        <v-col cols="4">
          <v-badge color="warning" bordered overlap content="6" left>
            <v-btn
              fab
              depressed
              :color="state === 'certificate' ? 'success' : 'error'"
              router
              :to="`/Book/Certificate/${bookId}`"
            >
              <v-icon>mdi-certificate-outline</v-icon>
            </v-btn>
          </v-badge>
          <div
            class="re-caption dastnevis text-center gray--text lighten-2 my-3"
          >
            ... بگیریم
          </div>
        </v-col>
      </v-row>
    </div>

    <v-btn class="my-9 mb-0 mx-auto" depressed small router to="/Books">
      بازگشت به لیست کتاب ها
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "menu-component",
  props: {
    bookId: { type: String, default: "" },
    state: { type: String, default: "" }
  }
};
</script>
<style scoped>
.re-menu {
  position: relative;
}
.re-caption {
  font-size: 13px;
}
.re-hr {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 1px;
  background-image: linear-gradient(
    to right,
    #555 33%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 15px 5px;
  background-repeat: repeat-x;
}
</style>
